import { render, staticRenderFns } from "./CampaignsSettings.vue?vue&type=template&id=ea0e3f42&scoped=true&"
import script from "./CampaignsSettings.vue?vue&type=script&lang=js&"
export * from "./CampaignsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsSettings.vue?vue&type=style&index=0&id=ea0e3f42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0e3f42",
  null
  
)

export default component.exports